export default __webpack_public_path__ + "static/media/tripnow.79840bc6.PNG";